module.exports = __webpack_public_path__ + "img/tabarok.ea335f60.png";